// FistOS control protocol — session management.
//
// Source of truth for the wire. Field numbers are append-only: never reuse or
// renumber; mark removed fields `reserved`.
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file session.proto.
 */
export const file_session = /*@__PURE__*/ fileDesc("Cg1zZXNzaW9uLnByb3RvEglmaXN0b3MudjEiiAEKBUhlbGxvEhgKEHByb3RvY29sX3ZlcnNpb24YASABKA0SEQoJZGV2aWNlX2lkGAIgASgJEhYKDmZpc3Rvc192ZXJzaW9uGAMgASgJEhkKEWJ1aWxkX2ZpbmdlcnByaW50GAQgASgJEg4KBmRldmljZRgFIAEoCRIPCgdib290X2lkGAYgASgJIj4KC1NlcnZlckhlbGxvEhEKCXNlcnZlcl9pZBgBIAEoCRIcChRoZWFydGJlYXRfaW50ZXJ2YWxfcxgCIAEoDSJuCglIZWFydGJlYXQSCwoDc2VxGAEgASgEEhEKCXVwdGltZV9tcxgCIAEoAxIXCg9iYXR0ZXJ5X3BlcmNlbnQYAyABKAUSEAoIY2hhcmdpbmcYBCABKAgSFgoOYWN0aXZlX3Rhc2tfaWQYBSABKAkiuAMKDENhcGFiaWxpdGllcxIVCg1hY2Nlc3NpYmlsaXR5GAEgASgIEhUKDWFwcF9mdW5jdGlvbnMYAiABKAgSEgoKc2NyZWVuc2hvdBgDIAEoCBIXCg9pbnB1dF9pbmplY3Rpb24YBCABKAgSFAoMY2FsbF9jb250cm9sGAUgASgIEhUKDWNhbGxfZG93bmxpbmsYBiABKAkSHQoVY2FsbF91cGxpbmtfaW5qZWN0aW9uGAcgASgIEhcKD2NhbGxfZm9yd2FyZGluZxgIIAEoCBIQCghzbXNfc2VuZBgJIAEoCBITCgtzbXNfcmVjZWl2ZRgKIAEoCBILCgNyY3MYCyABKAgSDgoGY2FtZXJhGAwgASgIEiwKB2NhbWVyYXMYDSADKAsyGy5maXN0b3MudjEuQ2FtZXJhRGVzY3JpcHRvchIVCg1zY3JlZW5fc3RyZWFtGA4gASgIEjEKBWV4dHJhGA8gAygLMiIuZmlzdG9zLnYxLkNhcGFiaWxpdGllcy5FeHRyYUVudHJ5GiwKCkV4dHJhRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASJcChBDYW1lcmFEZXNjcmlwdG9yEhEKCWNhbWVyYV9pZBgBIAEoCRIOCgZmYWNpbmcYAiABKAkSEQoJbWF4X3dpZHRoGAMgASgNEhIKCm1heF9oZWlnaHQYBCABKA0iLwoNRW5yb2xsUmVxdWVzdBINCgV0b2tlbhgBIAEoCRIPCgdjc3JfZGVyGAIgASgMIjwKDkVucm9sbFJlc3BvbnNlEhcKD2NlcnRpZmljYXRlX2RlchgBIAEoDBIRCgljaGFpbl9kZXIYAiADKAwiPAoFRXJyb3ISIgoEY29kZRgBIAEoDjIULmZpc3Rvcy52MS5FcnJvckNvZGUSDwoHbWVzc2FnZRgCIAEoCSrOAQoJRXJyb3JDb2RlEhoKFkVSUk9SX0NPREVfVU5TUEVDSUZJRUQQABIXChNFUlJPUl9DT0RFX1BST1RPQ09MEAESHgoaRVJST1JfQ09ERV9VTkFVVEhFTlRJQ0FURUQQAhIiCh5FUlJPUl9DT0RFX0VOUk9MTE1FTlRfUkVKRUNURUQQAxIaChZFUlJPUl9DT0RFX1VOU1VQUE9SVEVEEAQSEwoPRVJST1JfQ09ERV9CVVNZEAUSFwoTRVJST1JfQ09ERV9JTlRFUk5BTBAGYgZwcm90bzM");
/**
 * Describes the message fistos.v1.Hello.
 * Use `create(HelloSchema)` to create a new message.
 */
export const HelloSchema = /*@__PURE__*/ messageDesc(file_session, 0);
/**
 * Describes the message fistos.v1.ServerHello.
 * Use `create(ServerHelloSchema)` to create a new message.
 */
export const ServerHelloSchema = /*@__PURE__*/ messageDesc(file_session, 1);
/**
 * Describes the message fistos.v1.Heartbeat.
 * Use `create(HeartbeatSchema)` to create a new message.
 */
export const HeartbeatSchema = /*@__PURE__*/ messageDesc(file_session, 2);
/**
 * Describes the message fistos.v1.Capabilities.
 * Use `create(CapabilitiesSchema)` to create a new message.
 */
export const CapabilitiesSchema = /*@__PURE__*/ messageDesc(file_session, 3);
/**
 * Describes the message fistos.v1.CameraDescriptor.
 * Use `create(CameraDescriptorSchema)` to create a new message.
 */
export const CameraDescriptorSchema = /*@__PURE__*/ messageDesc(file_session, 4);
/**
 * Describes the message fistos.v1.EnrollRequest.
 * Use `create(EnrollRequestSchema)` to create a new message.
 */
export const EnrollRequestSchema = /*@__PURE__*/ messageDesc(file_session, 5);
/**
 * Describes the message fistos.v1.EnrollResponse.
 * Use `create(EnrollResponseSchema)` to create a new message.
 */
export const EnrollResponseSchema = /*@__PURE__*/ messageDesc(file_session, 6);
/**
 * Describes the message fistos.v1.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema = /*@__PURE__*/ messageDesc(file_session, 7);
/**
 * @generated from enum fistos.v1.ErrorCode
 */
export var ErrorCode;
(function (ErrorCode) {
    /**
     * @generated from enum value: ERROR_CODE_UNSPECIFIED = 0;
     */
    ErrorCode[ErrorCode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: ERROR_CODE_PROTOCOL = 1;
     */
    ErrorCode[ErrorCode["PROTOCOL"] = 1] = "PROTOCOL";
    /**
     * @generated from enum value: ERROR_CODE_UNAUTHENTICATED = 2;
     */
    ErrorCode[ErrorCode["UNAUTHENTICATED"] = 2] = "UNAUTHENTICATED";
    /**
     * @generated from enum value: ERROR_CODE_ENROLLMENT_REJECTED = 3;
     */
    ErrorCode[ErrorCode["ENROLLMENT_REJECTED"] = 3] = "ENROLLMENT_REJECTED";
    /**
     * @generated from enum value: ERROR_CODE_UNSUPPORTED = 4;
     */
    ErrorCode[ErrorCode["UNSUPPORTED"] = 4] = "UNSUPPORTED";
    /**
     * @generated from enum value: ERROR_CODE_BUSY = 5;
     */
    ErrorCode[ErrorCode["BUSY"] = 5] = "BUSY";
    /**
     * @generated from enum value: ERROR_CODE_INTERNAL = 6;
     */
    ErrorCode[ErrorCode["INTERNAL"] = 6] = "INTERNAL";
})(ErrorCode || (ErrorCode = {}));
/**
 * Describes the enum fistos.v1.ErrorCode.
 */
export const ErrorCodeSchema = /*@__PURE__*/ enumDesc(file_session, 0);
